import { getApi, postApi } from "./api_instance";

export const kyc = async (info, dispatch) => {
  try {
    return await postApi({
      apiUrl: "/api/kyc",
      sendToken: true,
      dispatch,
      data: info,
    });
  } catch (error) {
    throw error;
  }
};


export const getkyc = async ( dispatch) => {
  try {
    return await getApi({
      apiUrl: "/api/kyc/details",
      sendToken: true,
      dispatch,
    });
  } catch (error) {
    throw error;
  }
};
